import { render } from "./KitchenSinkView.vue?vue&type=template&id=249a8bf4&scoped=true"
import script from "./KitchenSinkView.vue?vue&type=script&lang=js"
export * from "./KitchenSinkView.vue?vue&type=script&lang=js"

import "./KitchenSinkView.vue?vue&type=style&index=0&id=249a8bf4&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-249a8bf4"

export default script